export default __webpack_public_path__ + "static/media/english-to-polish-logo.91e73b5e.png";